import { render, staticRenderFns } from "./ReviewFeedbackModal.vue?vue&type=template&id=562de2aa"
import script from "./ReviewFeedbackModal.vue?vue&type=script&lang=js"
export * from "./ReviewFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewFeedbackModal.vue?vue&type=style&index=0&id=562de2aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports